import { blocks, site, view } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import websiteDesignTriggerIds from 'src/js/modules/website-design/constants/trigger-ids';
import getParentBlockByElement from '../../blocks/helpers/get-parent-block-by-element';

const {
  track,
  trackers: { trackEvent },
  constants: { events },
} = segment;

function onDialogCancel({ dialogType, ...traits }) {
  switch (dialogType) {
    case dialogTypes.LINK_FORMATTING_DIALOG:
    case dialogTypes.EDIT_LINK_DIALOG:
    case dialogTypes.NAVIGATION_ITEM_SETTINGS_DIALOG:
    case dialogTypes.FOOTER_NAVIGATION_ITEM_SETTING_DIALOG: {
      trackEvent(events.LINK_SETTINGS_DIALOG_CANCELLED, {
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.FOOTER_NAVIGATION_SETTINGS_DIALOG: {
      trackEvent(events.LIST_SETTINGS_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.ADD_WIDGET: {
      trackEvent(events.WIDGET_SELECTOR_CLOSED, {
        ...traits,
      });
      break;
    }
    case dialogTypes.SELECT_ICON: {
      break;
    }
    case dialogTypes.BLOCK_SETTINGS: {
      trackEvent(events.BLOCK_SETTINGS_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.CONTACT_FORM_SETTINGS_DIALOG: {
      track(events.CONTACT_FORM_SETTINGS_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.CONTACT_FORM_NEW_ITEM: {
      track(events.CONTACT_FORM_ADD_ITEM_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.CONTACT_FORM_EDIT_ITEM: {
      track(events.CONTACT_FORM_EDIT_ITEM_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.CONTACT_FORM_DELETE_EMAIL_DIALOG: {
      track(events.CONTACT_FORM_DELETE_EMAIL_DIALOG_CANCELED, {
        ...traits,
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.GALLERY_DIALOG: {
      const { elementId, ...restTraits } = traits;
      const element = view.accessors.getLiveElement(elementId);
      const blockElement = getParentBlockByElement(element);

      trackEvent(events.GALLERY_SETTINGS_CANCELLED, {
        dialogId: dialogType,
        blockId: blocks.accessors.getBlockIdByElement(blockElement),
        ...restTraits,
      });

      break;
    }
    case dialogTypes.SLIDER_SETTINGS_DIALOG: {
      const { elementId, ...restTraits } = traits;
      const element = view.accessors.getLiveElement(elementId);
      const blockElement = getParentBlockByElement(element);

      trackEvent(events.SLIDER_SETTINGS_CANCELLED, {
        dialogId: dialogType,
        blockId: blocks.accessors.getBlockIdByElement(blockElement),
        ...restTraits,
      });

      break;
    }
    case dialogTypes.DIFM_PROMO_BANNER_DIALOG:
    case dialogTypes.DIFM_PROMO_FINISH_DIALOG:
    case dialogTypes.DIFM_PROMO_SERVICES_DIALOG:
    case dialogTypes.DIFM_PROMO_SURVEY_DIALOG:
    case dialogTypes.DIFM_PROMO_PACKAGES_DIALOG: {
      const { selectedService = null } = traits;

      trackEvent(events.DIFM_PROMO_DIALOG_CLOSED, {
        dialogId: dialogType,
        selectedService,
      });

      break;
    }
    case dialogTypes.BLOCK_REPLACEMENT_DIALOG: {
      const { oldBlock, oldBlockVariationId, newBlock, newBlockVariationId } = traits;

      trackEvent(events.BLOCK_REPLACEMENT_DIALOG_CANCELLED, {
        dialogId: dialogType,
        oldBlock,
        oldBlockVariationId,
        newBlock,
        newBlockVariationId,
      });

      break;
    }
    case dialogTypes.DESIGN_SETTINGS_CUSTOM_PALETTE: {
      trackEvent(events.DESIGN_SETTINGS_COLOR_PRESET_SETTINGS_CANCELED, {
        dialogId: dialogType,
      });
      break;
    }
    case dialogTypes.ADVANCED_COLORS_SETTINGS_DIALOG: {
      trackEvent(events.DESIGN_SETTINGS_COLOR_SCHEME_SETTINGS_CANCELED);
      break;
    }
    case dialogTypes.ADVANCED_COLOR_PICKER_DIALOG: {
      trackEvent(events.DESIGN_SETTINGS_COLOR_SETTINGS_CANCELLED, {
        dialogId: dialogType,
      });
      break;
    }

    case dialogTypes.SITE_WIZARD_SETUP_DIALOG:
    case dialogTypes.SITE_WIZARD_CONFIRM_EXIT_DIALOG:
    case dialogTypes.AI_TEXT_ASSISTANT_ERROR_DIALOG: {
      break;
    }

    case dialogTypes.AI_ERROR_DIALOG: {
      trackEvent(events.AI_WIZARD_ERROR_DIALOG_CLOSED, {
        businessCategory: site.accessors.getBusinessCategory(),
      });
      break;
    }

    case dialogTypes.AI_ONBOARDING_DIALOG: {
      trackEvent(events.AI_WIZARD_ONBOARDING_DIALOG_CLOSED, {
        ...traits,
        businessCategory: site.accessors.getBusinessCategory(),
      });
      break;
    }

    case dialogTypes.ADD_PAGE_DIALOG:
    case dialogTypes.NEW_PAGE_DIALOG: {
      trackEvent(events.ADD_PAGE_DIALOG_CANCELLED);
      break;
    }

    case dialogTypes.CREATE_FOLDER_DIALOG: {
      const { triggerId } = traits;

      trackEvent(events.ADD_FOLDER_DIALOG_CANCELLED, {
        triggerId,
      });
      break;
    }

    case dialogTypes.DELETE_PAGE:
    case dialogTypes.DELETE_FOLDER:
    case dialogTypes.BULK_EDITING_DELETE_DIALOG: {
      const { itemType, bulkEditing, itemsCount } = traits;
      trackEvent(events.PAGE_MANAGER_DELETE_DIALOG_CANCELLED, {
        itemType,
        bulkEditing,
        itemsCount,
      });
      break;
    }

    case dialogTypes.BULK_EDITING_MOVE_TO_DIALOG: {
      const { bulkEditing, itemsCount } = traits;
      trackEvent(events.PAGE_MANAGER_MOVE_TO_DIALOG_CANCELLED, {
        bulkEditing,
        itemsCount,
      });
      break;
    }

    case dialogTypes.FOLDER_SETTINGS: {
      const { folderName } = traits;

      trackEvent(events.FOLDER_SETTINGS_DIALOG_CANCELLED, {
        folderName,
      });
      break;
    }

    case dialogTypes.PAGE_SETTINGS: {
      trackEvent(events.PAGE_SETTINGS_CANCELLED, {
        dialogId: dialogType,
      });
      break;
    }

    case dialogTypes.WEBSITE_SETTINGS: {
      trackEvent(events.WEBSITE_SETTINGS_DIALOG_CANCELED);
      break;
    }

    case dialogTypes.TRANSLATE_PAGE: {
      const { bulkEditing } = traits;
      trackEvent(events.TRANSLATE_PAGE_DIALOG_CANCELED, {
        bulkEditing,
      });
      break;
    }

    case dialogTypes.BASE_COLORS_PICKER_DIALOG: {
      const { triggerId } = traits;
      const event =
        triggerId === websiteDesignTriggerIds.ADD_CUSTOM_PALETTE
          ? events.DESIGN_SETTINGS_NEW_PALETTE_CANCELED
          : events.DESIGN_SETTINGS_EDIT_PALETTE_CANCELED;

      trackEvent(event);
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_EFFECTS_DIALOG: {
      const { sourceId } = traits;

      trackEvent(events.DESIGN_SETTINGS_EFFECTS_DIALOG_CANCELED, {
        sourceId,
      });
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_BUTTONS_DIALOG: {
      const { sourceId } = traits;

      trackEvent(events.DESIGN_SETTINGS_BUTTONS_DIALOG_CANCELED, {
        sourceId,
      });
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_FONTS_DIALOG: {
      const { sourceId } = traits;

      trackEvent(events.DESIGN_SETTINGS_FONTS_DIALOG_CANCELED, {
        sourceId,
      });
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_COLORS_DIALOG: {
      const { sourceId } = traits;

      trackEvent(events.DESIGN_SETTINGS_COLORS_DIALOG_CANCELED, {
        sourceId,
      });
      break;
    }

    case dialogTypes.BUTTON_PRESET_SETTINGS: {
      const { buttonPreset } = traits;

      trackEvent(events.DESIGN_SETTINGS_BUTTON_PRESET_SETTINGS_CANCELED, {
        buttonPreset,
      });
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_OTHER_STYLES_DIALOG: {
      const { sourceId } = traits;

      trackEvent(events.DESIGN_SETTINGS_OTHER_STYLES_DIALOG_CANCELED, {
        sourceId,
      });
      break;
    }

    case dialogTypes.ADD_FONT_PAIR_DIALOG: {
      trackEvent(events.DESIGN_SETTINGS_ADD_NEW_FONT_PAIR_CANCELED, {
        dialogId: dialogType,
      });
      break;
    }

    case dialogTypes.DESIGN_SETTINGS_FONT_SETTINGS_DIALOG: {
      trackEvent(events.DESIGN_SETTINGS_FONT_SETTINGS_CANCELED, {
        dialogId: dialogType,
      });
      break;
    }

    case dialogTypes.EMBED_HTML_SETTINGS_DIALOG: {
      const { renderInEditor } = traits;

      trackEvent(events.CUSTOM_HTML_DIALOG_CANCELED, {
        renderInEditor,
      });

      break;
    }

    case dialogTypes.TEXT_CUSTOM_SPACING_DIALOG: {
      const { targetElement } = traits;
      const blockElement = getParentBlockByElement(targetElement);
      const blockId = blocks.accessors.getBlockIdByElement(blockElement);
      const blockVariationId = blocks.accessors.getVariationIdByElement(blockElement);

      trackEvent(events.TEXT_EDITING_CUSTOM_SPACING_DIALOG_CANCELED, {
        blockId,
        blockVariationId,
      });

      break;
    }

    case dialogTypes.ADD_COLOR_SCHEME_DIALOG: {
      trackEvent(events.ADD_COLOR_SCHEME_DIALOG_CANCELED);
      break;
    }

    case dialogTypes.ADD_LANGUAGE: {
      trackEvent(events.TRANSLATE_WEBSITE_DIALOG_CANCELED);
      break;
    }

    default: {
      trackEvent(events.DIALOG_CANCELLED, {
        dialogId: dialogType,
      });
    }
  }
}

export default onDialogCancel;
